// 功能可见性开关：界面隐藏但代码与后端能力保留，改回 true 即恢复显示
// - 设备资料（device archives）：当前实际未投入使用
// - 生产工单（production work orders）：当前实际未投入使用，统计中的生产部分一并隐藏
export const FEATURE_DEVICE_ARCHIVES = false
export const FEATURE_PRODUCTION_ORDERS = false
